import https from "@/utils/api";


export const getMaterialsType= ()=>{ //材料类型
  return https.get('screen/material/type').then(res=>{
    return res
  })
}
export const getMaterialsInfo= (params)=>{ //材料类型
  return https.post('screen/material/info',params).then(res=>{
    return res
  })
}
export const getDifferences = ()=>{ //超负差
  return https.get('screen/material/difference').then(res=>{
    return res
  })
}
export const getMaterialsReceive= (params,data)=>{ //收料记录
  return https.post('screen/material/receive',params,data).then(res=>{
    return res
  })
}
export const getVideo = ()=>{ //过磅视频监控
  return https.get('screen/material/video').then(res=>{
    return res
  })
}